export default __webpack_public_path__ + "static/arabian-avathar-5d9ea6317191df85e1b9da1139a45de3.jpg";